import Vue from "vue";

export const AdminEventBus = new Vue();
